<template>
  <div id="map">
    <Map :address="data.address.address+' '+data.address.town.name+' '+data.address.city.name+' '+data.address.country.name" />
  </div>
</template>

<script>
import Map from "@/components/Map";

export default {
  name: "Location",
  components: {
    Map,
  },
  props:{
    data: Object
  },
  data() {
    return {
      coordinates: {
        lat: 37.2181,
        lng: 28.3665,
      },
      address: 'Türkiye, Muğla'
    };
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/components/Location.vue